import { render, staticRenderFns } from "./OurWellCoordinatedTeamBlock.vue?vue&type=template&id=0f49d4c2&"
import script from "./OurWellCoordinatedTeamBlock.vue?vue&type=script&lang=js&"
export * from "./OurWellCoordinatedTeamBlock.vue?vue&type=script&lang=js&"
import style0 from "./OurWellCoordinatedTeamBlock.vue?vue&type=style&index=0&id=0f49d4c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports